/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {SignupWizard} from './SignupWizard'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      {/* <Route path='registration' element={<Registration />} /> */}
      <Route index element={<Login />} />
    </Route>
    <Route path='registration' element={<SignupWizard />} />
  </Routes>
)

export {AuthPage}
